import 'react-router';
import { RouteObject } from 'react-router-dom';

import { APP_TYPE } from './constants';

import { Error, ERROR_TYPE } from './app/components/Error';

import BbDocDetailPage from './app/pages/BbDocDetailPage';
import BbDocNewPage from './app/pages/BbDocNewPage';
import CeproDocDetailPage from './app/pages/CeproDocDetailPage';
import CeproDocNewPage from './app/pages/CeproDocNewPage';
import DmvsDtiDetailPage from './app/pages/DmvsDtiDetailPage';
import DmvsGadDetailPage from './app/pages/DmvsGadDetailPage';
import InitialImportDocDetailPage from './app/pages/InitialImportDocDetailPage';
import ManagerCheckDetailPage from './app/pages/ManagerCheckDetailPage';
import ManagerCheckListPage from './app/pages/ManagerCheckListPage';
import ManagerDocListPage from './app/pages/ManagerDocListPage';
import ManagerDocFilterPage from './app/pages/ManagerDocFilterPage';
import ManagerGeodesistDetailPage from './app/pages/ManagerGeodesistDetailPage';
import ManagerGeodesistListPage from './app/pages/ManagerGeodesistListPage';
import ManagerHomePage from './app/pages/ManagerHomePage';
import ManagerNewCheckPage from './app/pages/ManagerNewCheckPage';
import ManagerNewOrganizationPage from './app/pages/ManagerNewOrganizationPage';
import ManagerOrganizationListPage from './app/pages/ManagerOrganizationListPage';
import ManagerOrganizationPage from './app/pages/ManagerOrganizationPage';
import ManagerSubjectDetailPage from './app/pages/ManagerSubjectDetailPage';
import ManagerSubjectListPage from './app/pages/ManagerSubjectListPage';
import ManagerUserListPage from './app/pages/ManagerUserListPage';
import ManagerSvuDetailPage from './app/pages/ManagerSvuDetailPage';
import ManagerSvuListPage from './app/pages/ManagerSvuListPage';
import ManagerNewSvuPage from './app/pages/ManagerNewSvuPage';
import ManagerEpsiPage from './app/pages/ManagerEpsiPage';
import ManagerEpsiDetailPage from './app/pages/ManagerEpsiDetailPage';
import PodaniDTIDetailPage from './app/pages/PodaniDTIDetailPage';
import PodaniDTINewPage from './app/pages/PodaniDTINewPage';
import PodaniKADDetailPage from './app/pages/PodaniKADDetailPage';
import PodaniKADNewPage from './app/pages/PodaniKADNewPage';
import PrejimkaCheckDetailPage from './app/pages/PrejimkaCheckDetailPage';
import PrejimkaCheckListPage from './app/pages/PrejimkaCheckListPage';
import PrejimkaDocDetailPage from './app/pages/PrejimkaDocDetailPage';
import PrejimaDocListPage from './app/pages/PrejimkaDocListPage';
import PrejimkaDocNewPage from './app/pages/PrejimkaDocNewPage';
import PrejimaHomePage from './app/pages/PrejimkaHomePage';
import PrejimkaNewCheckPage from './app/pages/PrejimkaNewCheckPage';
import PrejimkaNewOrganizationPage from './app/pages/PrejimkaNewOrganizationPage';
import PrejimkaOrganizationListPage from './app/pages/PrejimkaOrganizationListPage';
import PrejimkaOrganizationPage from './app/pages/PrejimkaOrganizationPage';
import PrejimkaUserEditPage from './app/pages/PrejimkaUserEditPage';
import PrejimkaUserListPage from './app/pages/PrejimkaUserListPage';
import VydejDatasourceListPage from './app/pages/VydejDatasourceListPage';
import VydejExportToolListPage from './app/pages/VydejExportToolListPage';
import VydejExportToolDetailPage from './app/pages/VydejExportToolDetailPage';
import VydejNewExportToolPage from './app/pages/VydejNewExportToolPage';
import VydejHomePage from './app/pages/VydejHomePage';
import VydejNewOrderPage from './app/pages/VydejNewOrderPage';
import VydejNewOrderSuccessPage from './app/pages/VydejNewOrderSuccessPage';
import VydejNewPriceListItemPage from './app/pages/VydejNewPriceListItemPage';
import VydejNewPublishsetPage from './app/pages/VydejNewPublishsetPage';
import VydejNewTagPage from './app/pages/VydejNewTagPage';
import VydejOrderDetailPage from './app/pages/VydejOrderDetailPage';
import VydejOrderEditPage from './app/pages/VydejOrderEditPage';
import VydejOrderListPage from './app/pages/VydejOrderListPage';
import VydejEpsiOrderListPage from './app/pages/VydejEpsiOrderListPage';
import VydejEpsiOrderDetailPage from './app/pages/VydejEpsiOrderDetailPage';
import VydejPriceListItemDetailPage from './app/pages/VydejPriceListItemDetailPage';
import VydejPriceListPage from './app/pages/VydejPriceListPage';
import VydejServiceOrderListPage from './app/pages/VydejServiceOrderListPage';
import VydejNewServiceOrderPage from './app/pages/VydejNewServiceOrderPage';
import VydejServiceOrderDetailPage from './app/pages/VydejServiceOrderDetailPage';
import VydejPublishsetDetailPage from './app/pages/VydejPublishsetDetailPage';
import VydejPublishsetListPage from './app/pages/VydejPublishsetListPage';
import VydejTagDetailPage from './app/pages/VydejTagDetailPage';
import VydejTagListPage from './app/pages/VydejTagListPage';
import VydejUserDetailPage from './app/pages/VydejUserDetailPage';
import VydejChartDocPage from './app/pages/VydejChartDocPage';

export type RouteId = keyof typeof routeToUrl;
export type RouteUrlGetter<R extends RouteId> = (typeof routeToUrl)[R];
type FirstArgumentType<F extends (...args: any[]) => any> = F extends (
  arg: infer A,
  ...args: any[]
) => any
  ? A
  : never;
export type RouteUrlGetterParams<R extends RouteId> = FirstArgumentType<RouteUrlGetter<R>>;

// this is hack for getting template urls
const templateParams = {
  id: ':id' as any as string | number,
  appType: ':appType' as any as APP_TYPE,
};

/**
 * Select params from route
 */
type Params<T extends keyof typeof templateParams> = Pick<typeof templateParams, T>;

export type RouteParams<R extends RouteId> = FirstArgumentType<(typeof routeToUrl)[R]>;

export type AppRoute = RouteObject & {
  id: RouteId;
  isPrivate?: boolean;
};

export const routeToUrl = {
  signup: ({ appType }: Params<'appType'>) => `/${appType}/signup`,
  error: () => `/error` as const,
  docCheck: ({ appType, id }: Params<'appType' | 'id'>) => `/${appType}/checks/${id}`,
  docDetail: ({ appType, id }: Params<'appType' | 'id'>) => `/${appType}/docs/${id}`,
  docInitialImport: ({ appType, id }: Params<'appType' | 'id'>) => `/${appType}/import/${id}`,
  docPodaniDTI: ({ appType, id }: Params<'appType' | 'id'>) => `/${appType}/podanidti/${id}`,
  checkList: ({ appType }: Params<'appType'>) => `/${appType}/checks`,
  docList: ({ appType }: Params<'appType'>) => `/${appType}/docs`,

  prejimkaHome: () => '/prejimka' as const,
  prejimkaDocList: () => '/prejimka/docs' as const,
  prejimkaDocNew: () => `/prejimka/docs/new`,
  prejimkaDocDetail: ({ id }: Params<'id'>) => `/prejimka/docs/${id}`,
  prejimkaCheckList: () => '/prejimka/checks' as const,
  prejimkaNewCheck: () => `/prejimka/checks/new` as const,
  prejimkaCheckDetail: ({ id }: Params<'id'>) => `/prejimka/checks/${id}`,
  prejimkaUserList: () => '/prejimka/users' as const,
  prejimkaUserEdit: ({ id }: Params<'id'>) => `/prejimka/users/${id}/edit`,
  prejimkaOrganizationList: () => '/prejimka/organizations' as const,
  prejimkaNewOrganization: () => '/prejimka/organizations/new' as const,
  prejimkaOrganization: ({ id }: Params<'id'>) => `/prejimka/organizations/${id}`,

  managerHome: () => '/manager' as const,
  managerDocList: () => '/manager/docs' as const,
  managerDocFilter: ({ id }: Params<'id'>) => `/manager/docs/filter/${id}`,
  managerCheckList: () => '/manager/checks' as const,
  managerNewCheck: () => `/manager/checks/new` as const,
  managerCheckDetail: ({ id }: Params<'id'>) => `/manager/checks/${id}`,
  managerUserList: () => '/manager/users' as const,
  managerUserEdit: ({ id }: Params<'id'>) => `/manager/users/${id}/edit`,
  managerOrganizationList: () => '/manager/organizations' as const,
  managerNewOrganization: () => '/manager/organizations/new' as const,
  managerOrganization: ({ id }: Params<'id'>) => `/manager/organizations/${id}`,
  managerSubjectList: () => '/manager/subjects' as const,
  managerSubjectDetail: ({ id }: Params<'id'>) => `/manager/subjects/${id}`,
  managerGeodesistList: () => '/manager/geodesists' as const,
  managerGeodesistDetail: ({ id }: Params<'id'>) => `/manager/geodesists/${id}`,
  managerSvuList: () => '/manager/svu' as const,
  managerNewSvu: () => '/manager/svu/new' as const,
  managerSvuDetail: ({ id }: Params<'id'>) => `/manager/svu/${id}`,
  managerEpsi: () => '/manager/epsi' as const,
  managerEpsiDetail: ({ id }: Params<'id'>) => `/manager/epsi/${id}`,
  initialImportDocDetail: ({ id }: Params<'id'>) => `/manager/import/${id}`,
  podaniDTINew: () => `/manager/podanidti/new`,
  podaniDTIDetail: ({ id }: Params<'id'>) => `/manager/podanidti/${id}`,
  dmvsDtiDetail: ({ id }: Params<'id'>) => `/manager/dmvsdti/${id}`,
  dmvsGadDetail: ({ id }: Params<'id'>) => `/manager/dmvsgad/${id}`,
  ceproDocNew: () => `/manager/cepro/new`,
  ceproDocDetail: ({ id }: Params<'id'>) => `/manager/cepro/${id}`,
  bbDocNew: () => `/manager/bb/new`,
  bbDocDetail: ({ id }: Params<'id'>) => `/manager/bb/${id}`,
  podaniKADNew: () => `/manager/podanikad/new`,
  podaniKADDetail: ({ id }: Params<'id'>) => `/manager/podanikad/${id}`,

  vydejHome: () => '/vydej' as const,
  vydejUserDetail: ({ id }: Params<'id'>) => `/vydej/users/${id}`,
  vydejOrderList: () => '/vydej/orders' as const,
  vydejNewOrder: () => `/vydej/orders/new`,
  vydejNewOrderSuccess: ({ id }: Params<'id'>) => `/vydej/orders/new/${id}`,
  vydejOrderDetail: ({ id }: Params<'id'>) => `/vydej/orders/${id}`,
  vydejOrderEdit: ({ id }: Params<'id'>) => `/vydej/orders/edit/${id}`,
  vydejEpsiOrderList: () => '/vydej/epsi' as const,
  vydejEpsiOrderDetail: ({ id }: Params<'id'>) => `/vydej/epsi/${id}`,
  vydejNewPublishset: () => '/vydej/publishsets/new' as const,
  vydejPublishsetDetail: ({ id }: Params<'id'>) => `/vydej/publishsets/${id}`,
  vydejPublishsetList: () => '/vydej/publishsets' as const,
  vydejNewTag: () => '/vydej/tags/new' as const,
  vydejTagDetail: ({ id }: Params<'id'>) => `/vydej/tags/${id}`,
  vydejTagList: () => '/vydej/tags' as const,
  vydejDatasourceList: () => '/vydej/datasources' as const,
  vydejExportToolList: () => '/vydej/export-tools' as const,
  vydejNewExportTool: () => '/vydej/export-tools/new' as const,
  vydejExportToolDetail: ({ id }: Params<'id'>) => `/vydej/export-tools/${id}`,
  vydejPriceList: () => '/vydej/price-list' as const,
  vydejNewPriceListItem: () => '/vydej/price-list/new' as const,
  vydejPriceListItemDetail: ({ id }: Params<'id'>) => `/vydej/price-list/${id}`,
  vydejServiceOrderList: () => '/vydej/service-orders' as const,
  vydejNewServiceOrder: () => '/vydej/service-orders/new' as const,
  vydejServiceOrderDetail: ({ id }: Params<'id'>) => `/vydej/service-orders/${id}`,
  vydejChartDoc: () => '/vydej/charts' as const,
} as const;

export const routes: AppRoute[] = [
  {
    id: 'error',
    element: <Error type={ERROR_TYPE.ERROR} />,
  },
  // Přejímka
  {
    id: 'prejimkaHome',
    path: routeToUrl.prejimkaHome(),
    element: <PrejimaHomePage />,
  },
  {
    id: 'prejimkaDocList',
    path: routeToUrl.prejimkaDocList(),
    element: <PrejimaDocListPage />,
  },
  {
    id: 'prejimkaDocNew',
    path: routeToUrl.prejimkaDocNew(),
    element: <PrejimkaDocNewPage />,
  },
  {
    id: 'prejimkaDocDetail',
    path: routeToUrl.prejimkaDocDetail({ id: ':id' }),
    element: <PrejimkaDocDetailPage />,
  },
  {
    id: 'prejimkaCheckDetail',
    path: routeToUrl.prejimkaCheckDetail({ id: ':id' }),
    element: <PrejimkaCheckDetailPage />,
  },
  {
    id: 'prejimkaNewCheck',
    path: routeToUrl.prejimkaNewCheck(),
    element: <PrejimkaNewCheckPage />,
  },
  {
    id: 'prejimkaCheckList',
    path: routeToUrl.prejimkaCheckList(),
    element: <PrejimkaCheckListPage />,
  },
  {
    id: 'prejimkaUserList',
    path: routeToUrl.prejimkaUserList(),
    element: <PrejimkaUserListPage />,
  },
  {
    id: 'prejimkaUserEdit',
    path: routeToUrl.prejimkaUserEdit({ id: ':id' }),
    element: <PrejimkaUserEditPage />,
  },

  {
    id: 'prejimkaOrganizationList',
    isPrivate: true,
    path: routeToUrl.prejimkaOrganizationList(),
    element: <PrejimkaOrganizationListPage />,
  },
  {
    id: 'prejimkaNewOrganization',
    isPrivate: true,
    path: routeToUrl.prejimkaNewOrganization(),
    element: <PrejimkaNewOrganizationPage />,
  },
  {
    id: 'prejimkaOrganization',
    isPrivate: true,
    path: routeToUrl.prejimkaOrganization({ id: ':id' }),
    element: <PrejimkaOrganizationPage />,
  },

  // Manažer
  {
    id: 'managerHome',
    path: routeToUrl.managerHome(),
    element: <ManagerHomePage />,
  },
  {
    id: 'managerDocList',
    path: routeToUrl.managerDocList(),
    element: <ManagerDocListPage />,
  },
  {
    id: 'managerDocFilter',
    path: routeToUrl.managerDocFilter({ id: ':id' }),
    element: <ManagerDocFilterPage />,
  },
  {
    id: 'managerCheckDetail',
    path: routeToUrl.managerCheckDetail({ id: ':id' }),
    element: <ManagerCheckDetailPage />,
  },
  {
    id: 'managerNewCheck',
    path: routeToUrl.managerNewCheck(),
    element: <ManagerNewCheckPage />,
  },
  {
    id: 'managerCheckList',
    path: routeToUrl.managerCheckList(),
    element: <ManagerCheckListPage />,
  },
  {
    id: 'managerUserList',
    path: routeToUrl.managerUserList(),
    element: <ManagerUserListPage />,
  },
  {
    id: 'managerUserEdit',
    path: routeToUrl.managerUserEdit({ id: ':id' }),
    element: <ManagerUserListPage />,
  },

  {
    id: 'managerOrganizationList',
    isPrivate: true,
    path: routeToUrl.managerOrganizationList(),
    element: <ManagerOrganizationListPage />,
  },
  {
    id: 'managerNewOrganization',
    isPrivate: true,
    path: routeToUrl.managerNewOrganization(),
    element: <ManagerNewOrganizationPage />,
  },
  {
    id: 'managerOrganization',
    isPrivate: true,
    path: routeToUrl.managerOrganization({ id: ':id' }),
    element: <ManagerOrganizationPage />,
  },
  {
    id: 'managerSubjectList',
    path: routeToUrl.managerSubjectList(),
    element: <ManagerSubjectListPage />,
  },
  {
    id: 'managerSubjectDetail',
    path: routeToUrl.managerSubjectDetail({ id: ':id' }),
    element: <ManagerSubjectDetailPage />,
  },
  {
    id: 'managerGeodesistList',
    path: routeToUrl.managerGeodesistList(),
    element: <ManagerGeodesistListPage />,
  },
  {
    id: 'managerGeodesistDetail',
    path: routeToUrl.managerGeodesistDetail({ id: ':id' }),
    element: <ManagerGeodesistDetailPage />,
  },
  {
    id: 'managerSvuList',
    path: routeToUrl.managerSvuList(),
    element: <ManagerSvuListPage />,
  },
  {
    id: 'managerNewSvu',
    path: routeToUrl.managerNewSvu(),
    element: <ManagerNewSvuPage />,
  },
  {
    id: 'managerSvuDetail',
    path: routeToUrl.managerSvuDetail({ id: ':id' }),
    element: <ManagerSvuDetailPage />,
  },
  {
    id: 'managerEpsi',
    path: routeToUrl.managerEpsi(),
    element: <ManagerEpsiPage />,
  },
  {
    id: 'managerEpsiDetail',
    path: routeToUrl.managerEpsiDetail({ id: ':id' }),
    element: <ManagerEpsiDetailPage />,
  },
  {
    id: 'initialImportDocDetail',
    path: routeToUrl.initialImportDocDetail({ id: ':id' }),
    element: <InitialImportDocDetailPage />,
  },
  {
    id: 'podaniDTINew',
    path: routeToUrl.podaniDTINew(),
    element: <PodaniDTINewPage />,
  },
  {
    id: 'podaniDTIDetail',
    path: routeToUrl.podaniDTIDetail({ id: ':id' }),
    element: <PodaniDTIDetailPage />,
  },
  {
    id: 'podaniKADNew',
    path: routeToUrl.podaniKADNew(),
    element: <PodaniKADNewPage />,
  },
  {
    id: 'podaniKADDetail',
    path: routeToUrl.podaniKADDetail({ id: ':id' }),
    element: <PodaniKADDetailPage />,
  },
  {
    id: 'dmvsDtiDetail',
    path: routeToUrl.dmvsDtiDetail({ id: ':id' }),
    element: <DmvsDtiDetailPage />,
  },
  {
    id: 'dmvsGadDetail',
    path: routeToUrl.dmvsGadDetail({ id: ':id' }),
    element: <DmvsGadDetailPage />,
  },
  {
    id: 'ceproDocNew',
    path: routeToUrl.ceproDocNew(),
    element: <CeproDocNewPage />,
  },
  {
    id: 'ceproDocDetail',
    path: routeToUrl.ceproDocDetail({ id: ':id' }),
    element: <CeproDocDetailPage />,
  },
  {
    id: 'bbDocNew',
    path: routeToUrl.bbDocNew(),
    element: <BbDocNewPage />,
  },
  {
    id: 'bbDocDetail',
    path: routeToUrl.bbDocDetail({ id: ':id' }),
    element: <BbDocDetailPage />,
  },
  // VYDEJ
  {
    id: 'vydejHome',
    path: routeToUrl.vydejHome(),
    element: <VydejHomePage />,
  },
  {
    id: 'vydejUserDetail',
    path: routeToUrl.vydejUserDetail({ id: ':id' }),
    element: <VydejUserDetailPage />,
  },
  {
    id: 'vydejOrderList',
    path: routeToUrl.vydejOrderList(),
    element: <VydejOrderListPage />,
  },
  {
    id: 'vydejNewOrderSuccess',
    path: routeToUrl.vydejNewOrderSuccess({ id: ':id' }),
    element: <VydejNewOrderSuccessPage />,
  },
  {
    id: 'vydejNewOrder',
    path: routeToUrl.vydejNewOrder(),
    element: <VydejNewOrderPage />,
  },
  {
    id: 'vydejOrderDetail',
    path: routeToUrl.vydejOrderDetail({ id: ':id' }),
    element: <VydejOrderDetailPage />,
  },
  {
    id: 'vydejOrderEdit',
    path: routeToUrl.vydejOrderEdit({ id: ':id' }),
    element: <VydejOrderEditPage />,
  },
  {
    id: 'vydejEpsiOrderList',
    path: routeToUrl.vydejEpsiOrderList(),
    element: <VydejEpsiOrderListPage />,
  },
  {
    id: 'vydejEpsiOrderDetail',
    path: routeToUrl.vydejEpsiOrderDetail({ id: ':id' }),
    element: <VydejEpsiOrderDetailPage />,
  },
  {
    id: 'vydejNewPublishset',
    path: routeToUrl.vydejNewPublishset(),
    element: <VydejNewPublishsetPage />,
  },
  {
    id: 'vydejPublishsetDetail',
    path: routeToUrl.vydejPublishsetDetail({ id: ':id' }),
    element: <VydejPublishsetDetailPage />,
  },
  {
    id: 'vydejPublishsetList',
    path: routeToUrl.vydejPublishsetList(),
    element: <VydejPublishsetListPage />,
  },
  {
    id: 'vydejNewTag',
    path: routeToUrl.vydejNewTag(),
    element: <VydejNewTagPage />,
  },
  {
    id: 'vydejTagDetail',
    isPrivate: true,
    path: routeToUrl.vydejTagDetail({ id: ':id' }),
    element: <VydejTagDetailPage />,
  },
  {
    id: 'vydejTagList',
    path: routeToUrl.vydejTagList(),
    element: <VydejTagListPage />,
  },
  {
    id: 'vydejDatasourceList',
    path: routeToUrl.vydejDatasourceList(),
    element: <VydejDatasourceListPage />,
  },
  {
    id: 'vydejExportToolList',
    path: routeToUrl.vydejExportToolList(),
    element: <VydejExportToolListPage />,
  },
  {
    id: 'vydejNewExportTool',
    path: routeToUrl.vydejNewExportTool(),
    element: <VydejNewExportToolPage />,
  },
  {
    id: 'vydejExportToolDetail',
    path: routeToUrl.vydejExportToolDetail({ id: ':id' }),
    element: <VydejExportToolDetailPage />,
  },
  {
    id: 'vydejPriceList',
    path: routeToUrl.vydejPriceList(),
    element: <VydejPriceListPage />,
  },
  {
    id: 'vydejNewPriceListItem',
    path: routeToUrl.vydejNewPriceListItem(),
    element: <VydejNewPriceListItemPage />,
  },
  {
    id: 'vydejServiceOrderList',
    path: routeToUrl.vydejServiceOrderList(),
    element: <VydejServiceOrderListPage />,
  },
  {
    id: 'vydejNewServiceOrder',
    path: routeToUrl.vydejNewServiceOrder(),
    element: <VydejNewServiceOrderPage />,
  },
  {
    id: 'vydejServiceOrderDetail',
    path: routeToUrl.vydejServiceOrderDetail({ id: ':id' }),
    element: <VydejServiceOrderDetailPage />,
  },
  {
    id: 'vydejPriceListItemDetail',
    path: routeToUrl.vydejPriceListItemDetail({ id: ':id' }),
    element: <VydejPriceListItemDetailPage />,
  },
  {
    id: 'vydejChartDoc',
    path: routeToUrl.vydejChartDoc(),
    element: <VydejChartDocPage />,
  },
] as const;
